import {useQuery} from "react-query";
import {useSelector} from "react-redux";
import * as CustomerService from ".././services/customer-service";

export default function useCustomers() {
  const authState = useSelector((state) => state.auth);
  return useQuery("customers", () => CustomerService.fetchCustomers(authState.roles), {
    refetchOnWindowFocus: false,
  });
}
